import request from './request'

export function listShift(data) {
  return request.post('/mes/shifts/list', data)
}
export function selectShift() {
  return request.get('/mes/shifts/select')
}
export function getShift(id) {
  return request.get('/mes/shifts/' + id)
}
export function saveShift(data) {
  return request.post('/mes/shifts', data)
}
export function updateShift(data) {
  return request.post('/mes/shifts/update', data)
}
export function deleteShift(ids) {
  return request.post('/mes/shifts/delete', ids)
}
